import styled from "styled-components";

const StyledIconWrapper = styled.div`
  flex-shrink: 1;
`;

export default StyledIconWrapper;
